<div class="flex-column full-height">
  <vdw-tabs-menu-card
    icon="library-blue"
    title="{{ 'DESIGN_LIBRARY.DESIGN_LIBRARY' | bmsTranslate }} {{ 'GENERAL.CUSTOM_SETTINGS.SETTINGS_FOR_OBJECT' | bmsTranslate: {object: ''} }}"
    [invalidFormMessageError]="canShowInvalidFormMessageError()"
    [saving]="saving"
    [canShowCancel]="canShowCancelButton()"
    (cancelEvent)="navigateBack()"
    (saveEvent)="saveCustomSettings()"
  ></vdw-tabs-menu-card>

  <form [formGroup]="customSettingsForm" class="flex-row overflow-hidden">
    <mat-card class="no-margin half-width">
      <mat-card-content class="overflow-auto">
        <article fxLayout="column">
          <div fxLayout="row" fxLayoutGap="16px">
            <mat-form-field class="flex-grow">
              <mat-label>{{ 'DESIGN_LIBRARY.SETTINGS.WIDTH_ROUNDING_PRECISION' | bmsTranslate }}</mat-label>
              <mat-select formControlName="widthRoundingPrecision" disableOptionCentering>
                <mat-option *ngFor="let roundingPrecisionOption of possibleWidthRoundingPrecisions" [value]="roundingPrecisionOption">
                  {{ roundingPrecisionOption }} {{ 'GENERAL.UNIT.CENTIMETER' | bmsTranslate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-grow">
              <mat-label>{{ 'DESIGN_LIBRARY.SETTINGS.HEIGHT_ROUNDING_PRECISION' | bmsTranslate }}</mat-label>
              <mat-select formControlName="heightRoundingPrecision" disableOptionCentering>
                <mat-option *ngFor="let roundingPrecisionOption of possibleHeightRoundingPrecisions" [value]="roundingPrecisionOption">
                  {{ roundingPrecisionOption }} {{ 'GENERAL.UNIT.CENTIMETER' | bmsTranslate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutGap="16px">
            <mat-form-field class="flex-grow">
              <mat-label>{{ 'DESIGN_LIBRARY.SETTINGS.BATH_THRESHOLD' | bmsTranslate }}</mat-label>
              <input matInput vdwL10nDecimal [decimals]="true" [maximumFractionDigits]="2" formControlName="bathThreshold" />
              <span matSuffix>{{ 'GENERAL.UNIT.PERCENTAGE' | bmsTranslate }}</span>

              <mat-error *vdwCanShowErrorForFormControl="'bathThreshold'; error: 'required'">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
              <mat-error *vdwCanShowErrorForFormControl="'bathThreshold'; error: 'min'"> {{ 'GENERAL.VALIDATION.MINIMUM' | bmsTranslate }}: 1 </mat-error>
              <mat-error *vdwCanShowErrorForFormControl="'bathThreshold'; error: 'max'"> {{ 'GENERAL.VALIDATION.MAXIMUM' | bmsTranslate }}: 100 </mat-error>
            </mat-form-field>
            <app-label-placeholder
              class="flex-grow"
              [listOfPlaceholderCategoriesWithComponents]="listOfPlaceholderCategoriesWithComponents"
              [placeholderParts]="placeholderParts"
              [buttonTitle]="'DESIGN_LIBRARY.SETTINGS.SPECIFY_PARTS_OF_DESIGN_NAME'"
              [linkFormInputPlaceholder]="'DESIGN_LIBRARY.SETTINGS.DESIGN_NAME_PATTERN'"
              [separatorForTextPlaceholder]="separatorForTextPlaceholder"
              [requiredMaxLength]="true"
              (placeholderPartsChanged)="placeholderPartsChanged($event)"
            >
            </app-label-placeholder>
          </div>
          <div class="design-shapes-container" fxLayout="row">
            <mat-card class="no-margin" fxLayout="column" fxFlex="100">
              <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
                <mat-card-title>
                  <h3 class="font-weight-semibold">{{ titleTranslationKey | bmsTranslate }}</h3>
                </mat-card-title>
                <div class="actions" *appHasPermission="addDesignShapePermission">
                  <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'GENERAL.ACTIONS.CREATE_NEW' | bmsTranslate" (click)="addDesignShape()">
                    <mat-icon svgIcon="add"></mat-icon>
                  </button>
                </div>
              </mat-card-header>
              <mat-card-content fxLayout="row">
                <div fxLayout="column" fxFlex="14">
                  <h4 fxLayout="row" fxLayoutAlign="start center" fxFlex="56px" class="design-shapes-cell design-shapes-header font-weight-semibold">
                    {{ 'DESIGN_LIBRARY.SETTINGS.DEFAULT' | bmsTranslate }}
                  </h4>
                  <div fxLayout="row" fxFlex>
                    <mat-radio-group formControlName="shape" fxLayout="column" fxFlex="100">
                      <div class="design-shapes-cell" fxFlayout="row" fxFlex="89px" *ngFor="let drawingShape of drawingShapes" fxLayoutAlign="start center">
                        <mat-radio-button [value]="drawingShape"></mat-radio-button>
                      </div>
                    </mat-radio-group>
                  </div>
                </div>
                <div fxLayout="column" fxFlex="25" formArrayName="shapes">
                  <h4 fxLayout="row" fxLayoutAlign="start center" fxFlex="56px" class="design-shapes-cell design-shapes-header font-weight-semibold">{{ 'GENERAL.NAME' | bmsTranslate }}</h4>

                  <ng-container *ngFor="let shape of shapes.controls; let index = index">
                    <div class="design-shapes-cell" fxFlayout="row" fxLayoutAlign="start center" fxFlex="89px" *ngIf="isDefaultShape(shape.value.shape)">
                      <app-disabled-form-input fxFlex="100" [value]="getLabel(shape.value.shape)"></app-disabled-form-input>
                    </div>
                    <div *ngIf="!isDefaultShape(shape.value.shape)" class="design-shapes-cell" fxFlayout="row" fxFlex="89px" fxLayoutAlign="start center" [formGroupName]="index">
                      <mat-form-field class="full-width no-subscript">
                        <input matInput [tabindex]="index + 1" formControlName="shape" (change)="onShapeNameChange(index)" />
                        <mat-error *vdwCanShowErrorForFormControl="'shapes.' + index + '.shape'; error: 'required'">
                          {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                        </mat-error>
                        <mat-error *vdwCanShowErrorForFormControl="'shapes.' + index + '.shape'; error: 'uniqueShape'"> {{ 'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate }} </mat-error>
                      </mat-form-field>
                    </div>
                  </ng-container>
                </div>
                <div fxLayout="column" fxFlex="25" formArrayName="codes">
                  <h4 fxLayout="row" fxLayoutAlign="start center" fxFlex="56px" class="design-shapes-cell design-shapes-header font-weight-semibold">{{ 'GENERAL.CODE' | bmsTranslate }}</h4>
                  <ng-container>
                    <div class="design-shapes-cell" fxLayout="row" fxLayoutAlign="start center" fxFlex="89px" *ngFor="let code of codes.controls; let index = index" [formGroupName]="index">
                      <mat-form-field class="full-width no-subscript">
                        <input matInput [tabindex]="index + 1" formControlName="code" (change)="onShapeCodeChange(index)" />
                        <mat-error *vdwCanShowErrorForFormControl="'codes.' + index + '.code'; error: 'required'">
                          {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                        </mat-error>
                        <mat-error *vdwCanShowErrorForFormControl="'codes.' + index + '.code'; error: 'uniqueCode'"> {{ 'GENERAL.ERRORS.CODE_DUPLICATE' | bmsTranslate }} </mat-error>
                      </mat-form-field>
                    </div>
                  </ng-container>
                </div>
                <div fxLayout="column" fxFlex="26">
                  <h4 fxLayout="row" fxLayoutAlign="start center" fxFlex="56px" class="design-shapes-cell design-shapes-header font-weight-semibold">
                    {{ 'DESIGN_LIBRARY.SETTINGS.WOVEN_REPEATEDLY' | bmsTranslate }}
                  </h4>
                  <div fxLayout="column" fxFlex>
                    <div class="design-shapes-cell" fxLayout="row" fxLayoutAlign="start center" fxFlex="89px" *ngFor="let drawingShape of drawingShapes; let index = index">
                      <mat-slide-toggle
                        color="primary"
                        *ngIf="canShowWovenRepeatedly(drawingShape.shape)"
                        [tabindex]="index + 1"
                        [disabled]="canDisableWovenRepeatedly(drawingShape.shape)"
                        [checked]="drawingShape.repeated"
                        (change)="onWovenRepeatedlyChange(index)"
                      ></mat-slide-toggle>
                    </div>
                  </div>
                </div>
                <div fxLayout="column" fxFlex="10">
                  <h4 fxLayout="row" fxLayoutAlign="start center" fxFlex="56px" class="design-shapes-cell design-shapes-header font-weight-semibold"></h4>
                  <div fxLayout="column" fxFlex>
                    <div class="design-shapes-cell" fxFlayout="row" fxFlex="89px" *ngFor="let drawingShape of drawingShapes; let index = index" fxLayoutAlign="end center">
                      <button
                        *ngIf="!isDefaultShape(drawingShape.shape)"
                        mat-icon-button
                        [tabindex]="index + 1"
                        class="mat-icon-action-button-lg-with-border"
                        [matTooltip]="'GENERAL.ACTIONS.DELETE' | bmsTranslate"
                        (click)="removeDesignShape(drawingShape)"
                      >
                        <mat-icon svgIcon="trash"></mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </article>
      </mat-card-content>
    </mat-card>
  </form>
</div>
